import React from 'react';
import { MenuSectionType } from 'types/graphql';
import { LocalSection, Products } from '../homepage-form.types';
import { AddCategoryModal } from './add-category-modal';
import { BrandModal } from './brand-modal';
import { CustomModal } from './custom-modal';
import { AddCollectionModal } from './add-collection-modal';
import AddImageSection from './add-image-section';

export type ModalControllerProps = {
  handleAddSection: (newSection: LocalSection) => void;
  menuSection: LocalSection | null;
  menuSections: LocalSection[] | null;
  onToggle: () => void;
  products: Products | null;
  sectionTypeKey: MenuSectionType;
};

const sectionTypeToModal: Record<MenuSectionType, React.FC<ModalControllerProps> | null> = {
  [MenuSectionType.brand]: BrandModal,
  [MenuSectionType.category]: AddCategoryModal,
  [MenuSectionType.collection]: AddCollectionModal,
  [MenuSectionType.custom]: CustomModal,
  [MenuSectionType.image]: AddImageSection,
  [MenuSectionType.offers]: null,
  [MenuSectionType.recentlyViewed]: null,
  [MenuSectionType.recommendedForYou]: null,
  [MenuSectionType.specials]: null,
  [MenuSectionType.staffPicks]: null,
  [MenuSectionType.subcategory]: AddCategoryModal,
  [MenuSectionType.topSellers]: null,
};

export function ModalController(props: ModalControllerProps): JSX.Element | null {
  const { sectionTypeKey } = props;
  const Modal = sectionTypeToModal[sectionTypeKey];

  if (!Modal) {
    return null;
  }

  return <Modal {...props} />;
}
